<template>
  <div class="p_supply_module p_fee_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队名称</div>
                    <el-input v-model="listQuery.strConstrteamName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput" v-if="!isTeamRemind">
                  <div class="flname">姓名</div>
                  <el-input v-model="listQuery.strPerName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-loading="tableLoading">
            <div v-if="isTeamRemind">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick01">
                    <el-tab-pane v-if="checkPermission(['supplierManage_tab_list'],permissionLists)" label="施工队列表" name="first"></el-tab-pane>
                    <el-tab-pane v-if="checkPermission(['supplierManage_tab_remind'],permissionLists)" label="施工队提醒" name="second"></el-tab-pane>
                    <el-tab-pane v-if="checkPermission(['supplierManage_tab_recertification'],permissionLists)" label="施工队重新认证列表" name="third"></el-tab-pane>
                </el-tabs>
            </div>
            <div v-if="!isTeamRemind">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick01">
                    <el-tab-pane v-if="checkPermission(['teamMembers_tab_list'],permissionLists)" label="施工队员列表" name="first"></el-tab-pane>
                    <el-tab-pane v-if="checkPermission(['teamMembers_tab_remind'],permissionLists)" label="施工队员提醒" name="second">
                        <el-tabs v-model="activeMemName" @tab-click="handleClick02" class="p_mem_tabs">
                            <!-- <el-tab-pane :label="'全部('+total+')'" name="first"></el-tab-pane> -->
                            <el-tab-pane :label="'电工证('+count1+')'" name="second"></el-tab-pane>
                            <el-tab-pane :label="'意外险保单('+count2+')'" name="third"></el-tab-pane>
                            <el-tab-pane :label="'上岗证('+count3+')'" name="fourth"></el-tab-pane>
                            <el-tab-pane :label="'身份证('+count4+')'" name="five"></el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
          </div>
         <!-- :cell-style="addClass" -->
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" border :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <el-table-column align="center" label="到期剩余天数" fixed min-width="100px" class="remind_tr">
              <template slot-scope="{row}">
                <span :class="Number(row.Lostdate)<0?'remind_txt':'remind_txt01'">{{Number(row.Lostdate)<0?'已过期' : row.Lostdate+' 天'}}</span>
              </template>
            </el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('代码')>-1||item.StrColumName.indexOf('套餐')>-1||item.StrColumName.indexOf('负责人身份证')>-1 ? '160px' : item.StrColumName.indexOf('名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('电子邮箱')>-1||item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('有效期')>-1||item.StrColumName.indexOf('施工')>-1||item.StrColumName.indexOf('次数')>-1?'150px':'110px'" align="center"
                :fixed="item.StrColumName=='施工队名称'||item.StrColumName=='施工队编号'">
                <template slot-scope="{row}">
                  <p v-if="item.StrColumId=='StrConstrteamName'" class="auth_box">
                    <img src="./../../assets/images/auth.png" alt="" v-if="row.StrExamStatus=='已认证'">
                    <span class="auth_title">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                  </p>
                  <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        //禁用日期范围
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
            }
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_busi_ConstrTeam', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        isTeamRemind:true,//是否是施工队跳转过来
        teamList:[],//施工队列表
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'施工队提醒',
        activeName:'second',
        activeMemName:'second',
        tableData: [],
        listQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          strPerName:'',//  姓名
          strDutie:'',// 职务(人员分类)
          strremindType:'电工证',//电工证,意外险保单,上岗证,身份证
          currpage:1,
          perpage:10
        },
        memListQuery:{
            strConstrteamName:'',// 施工队名称
            strPerName:'',//  姓名
            strDutie:'',// 职务(人员分类)
            strArea:'',// 区域
            strCityCompany:'',// 城市公司
            currpage:1,
            perpage:10
        },
        custPath: '',//导出文件下载路径
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        tablePath: this.$store.state.EMP.tablePath,
        //角色类型
        roleType: '',
        teamQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          currpage:1,
          perpage:1000000
        },
        count1:0,
        count2:0,
        count3:0,
        count4:0,
        // 按钮权限参数
        butQuery:{
          path:'/supplierManage',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      this.roleType = localStorage.loginRoletype
      if(this.$route.query.jumpname == 'team'){//从施工队跳转来
          this.isTeamRemind = true
          this.butQuery = {
            path:'/supplierManage',
            powerEnName:'supplierManage'
          }
          if(!this.isNull(this.$route.query.active)){
            this.activeName = this.$route.query.active
            if(this.activeName == 'first'){
              this.$router.push({
                  path: '/supplierManage',
                  query:{
                      active:'first'
                  }
              })
            }
            if(this.activeName == 'second'){
              // 表头
              this.getTableTitleLists()
            }
            if(this.activeName == 'third'){
              this.$router.push({
                  path: '/recertification',
                  query:{
                      active:'third'
                  }
              })
            }
          }
        }else{//从施工队员跳过来
            this.isTeamRemind = false
            this.pageCrumb = '施工队员提醒'
            this.butQuery = {
              path:'/teamMembers',
              powerEnName:'supplierManage'
            }
            if(!this.isNull(this.$route.query.active)){
              this.activeName = this.$route.query.active
              if(this.activeName == 'first'){
                this.$router.push({
                    path: '/teamMembers',
                    query:{
                        active:'first'
                    }
                })
              }else{
                // 表头
                this.getTableTitleLists()
              }
            }
        }
        this.getButtonPower()
    },
    methods: {
      checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              that.permissionLists.push(element.Enname);
            }
            if(that.isTeamRemind == true){//从施工队跳转的
                if(that.checkPermission(['supplierManage_tab_list'],that.permissionLists)&&(that.isNull(that.$route.query.active))){
                  that.$router.push({
                      path: '/supplierManage',
                      query:{
                        active:'first'
                    }
                  })
                }else if((!that.checkPermission(['supplierManage_tab_list'],that.permissionLists))&&(that.checkPermission(['supplierManage_tab_remind'],that.permissionLists))&&(!that.checkPermission(['supplierManage_tab_recertification'],that.permissionLists))&&(that.isNull(that.$route.query.active))){
                  that.activeName = 'second'
                }else if((!that.checkPermission(['supplierManage_tab_list'],that.permissionLists))&&(!that.checkPermission(['supplierManage_tab_remind'],that.permissionLists))&&(that.checkPermission(['supplierManage_tab_recertification'],that.permissionLists))&&(that.isNull(that.$route.query.active))){
                  that.$router.push({
                  path: '/recertification',
                  query:{
                      active:'third'
                  }
                })
              }
            }else{
              if(that.checkPermission(['teamMembers_tab_list'],that.permissionLists)&&(that.isNull(that.$route.query.active))){
                  that.$router.push({
                      path: '/teamMembers',
                      query:{
                        active:'first'
                    }
                  })
                }else if((!that.checkPermission(['teamMembers_tab_remind'],that.permissionLists))&&(that.checkPermission(['supplierManage_tab_remind'],that.permissionLists))&&(!that.checkPermission(['supplierManage_tab_recertification'],that.permissionLists))&&(that.isNull(that.$route.query.active))){
                  that.activeName = 'second'
                }
            }
          }else{
            if(that.isTeamRemind == true){
              this.permissionLists = []
              this.activeName = ''
            }else{
              this.permissionLists = []
              this.activeName = ''
            }
          }
        }else{
          if(that.isTeamRemind == true){
            this.permissionLists = []
            this.activeName = ''
          }else{
            this.permissionLists = []
            this.activeName = ''
          }
        }
      })
    },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 大类tab
        handleClick01(tab, event) {
            // console.log(tab, event);
            this.activeName = tab.name
            if(this.isTeamRemind){
                this.pageCrumb = '施工队提醒'
                if(tab.name == 'first'){
                    this.$router.push({
                        path: '/supplierManage',
                        query: {
                          active:'first'
                        }
                    })
                }else if(tab.name == 'third'){
                    this.$router.push({
                        path: '/recertification',
                        query: {
                          active:'third'
                        }
                    })
                }
            }else{
                this.pageCrumb = '施工队员提醒'
                if(tab.name == 'first'){
                    this.$router.push({
                        path: '/teamMembers',
                        query: {
                          active:'first'
                        }
                    })
                }
            }
        },
        // 施工队员提醒tab
        handleClick02(tab, event) {
            // console.log(tab, event);
            this.activeMemName = tab.name
            if(tab.name == 'first'){
                this.listQuery.strremindType = ''
            }else if(tab.name == 'second'){
                this.listQuery.strremindType = '电工证'
            }else if(tab.name == 'third'){
                this.listQuery.strremindType = '意外险保单'
            }else if(tab.name == 'fourth'){
                this.listQuery.strremindType = '上岗证'
            }else if(tab.name == 'five'){
                this.listQuery.strremindType = '身份证'
            }
            this.listQuery.currpage = 1
            this.getList()
        },
        // 获取表头
        getTableTitleLists(){
          if(this.activeName == 'first'){//施工队提醒列表
            this.titleQuery.strTableId = 'JB_busi_ConstrTeam'
          }else{
            this.titleQuery.strTableId = 'JB_busi_ConstrPerson'
          }
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            if(this.isTeamRemind){//施工队提醒列表
                xz.getConstrTeamremind(this.listQuery).then(res => {
                    // console.log('getList', res)
                    if (res.status == 'ok') {
                        this.tableData = res.msg
                        this.total = res.totalcount
                    }else{
                        this.tableData = []
                        this.total = 0
                    }
                    this.tableLoading = false
                    this.isSearchHandle = false
                })
            }else{//施工队员提醒列表
                xz.getConstrTeamPersonremind(this.listQuery).then(res => {
                    // console.log('getList', res)
                    if (res.status == 'ok') {
                        this.tableData = res.msg
                        this.total = res.totalcount
                        this.count1 = res.count1
                        this.count2 = res.count2
                        this.count3 = res.count3
                        this.count4 = res.count4
                    }else{
                        this.tableData = []
                        this.total = 0
                        this.count1 = 0
                        this.count2 = 0
                        this.count3 = 0
                        this.count4 = 0
                    }
                    this.tableLoading = false
                    this.isSearchHandle = false
                })
            }
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        calDaysBetween(date) {
            let startDate = Date.parse(date);
            let endDate = Date.parse(new Date());
            let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            days > 7 ? this.isDownFeeTemplate = false : this.isDownFeeTemplate = true;
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.teamList = res.msg
                }else{
                  this.teamList = []
                }
            })
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
          this.listQuery = this.$options.data.call(this).listQuery
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        addClass({row,column,rowIndex,columnIndex}){
            // console.log(column);
            // if(column.property == 'Lostdate'){
                if(Number(row.Lostdate)>0||Number(row.Lostdate)==0){
                    return 'background: #F56C6C;color:white';
                }
            // }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.remind_txt{
    color:#F56C6C;
    font-weight: bold;
}
.remind_txt01{
    color:#85ce61;
    font-weight: bold;
}
.auth_box{
  display: flex;
  align-items: center;
}
.auth_title{
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.auth_box img{
  width: 20px;
  height: 20px;
}
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
}
.p_supply_module .el-tabs.p_mem_tabs{
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>